/**
 * @fileoverview Skeleton component for loading placeholders.
 * Provides animated placeholder while content loads.
 * @module components/ui/skeleton
 */

import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Skeleton placeholder with pulse animation.
 * Used to indicate loading state.
 * @param props - HTML div props
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
}

export { Skeleton }
